const supportsLoadingAttribute = 'loading' in HTMLImageElement.prototype;

export default async () => {
  if (supportsLoadingAttribute) {
    return;
  }

  const { default: init } = await import('./lazysizes');

  init();
};
